export const FETCH_BASE_TOKEN = 'base_token';
export const FETCH_LOGIN_TOKEN = 'login_token';
export const REFRESH_LOGIN_TOKEN = 'refresh_login_token';
export const LOGOUT = 'logout';
export const FETCH_INS_OFFERS = 'ins_offers';
export const FETCH_REG_PROPS = 'reg_props';
export const FETCH_LOCATION = 'location';
export const FETCH_INS_COMPANIES = 'ins_companies';
export const UPDATE_INITIAL_DATA = 'initial_data';
export const UPDATE_QUESTIONS_POLICY = 'questions_policy'
export const FETCH_DISTRICTS = 'districts';
export const SET_SELLECTED_OFFER = 'set_selected_offer';
export const SET_REVISED_OFFER = 'set_revised_offer';
export const UPDATE_REVISED_OFFER = 'update_revised_offer';
export const SET_TALON_PICTURE = 'set_talon_picture';
export const UPDATE_OWNER_DETAILS = 'update_owner_details';
export const UPDATE_USER_DETAILS = 'update_user_details';
export const CLEAR_USER_DETAILS = 'clear_user_details';
export const UPDATE_SHIPMENT_DETAILS = 'update_shipment_details';
export const UPDATE_USER_ADDRESS = 'update_user_address';
export const FETCH_USER_ADDRESSES = 'fetch_user_addresses';
export const CREATE_INS_CONTRACT = 'create_ins_contract';
export const CREATE_INS_CONTRACT_FAILED = 'create_ins_contract_failed';
export const PAYMENT_WITH_CARD = 'payment_with_card';
export const GET_PAYMENT_CARDS = 'get_payment_cards';
export const FETCH_MY_POLICIES = 'fetch_my_policies';
export const SET_STEP_LIABILITY = 'set_step_liability';
export const SET_GO_TO_LIABILITY = 'set_go_to_liability';
export const CLEAR_NEW_LIABILITY_POLICY ='clear_new_liability_policy';
export const SET_NEWS_DATA = 'set_news_data';
export const ADD_NEWS_DATA = 'add_news_data';

